import { Typography } from "antd";
import { t } from "i18next";
import "./index.scss";

// Ghi chú chính sách vận chuyển — text tĩnh, luôn hiển thị ở khối PTVC (không phụ thuộc giá trị đơn).
const NOTE_KEYS = ["urbanCOD", "pickUpCounter", "instant", "busAndDeliver3Party"];

const ShippingPolicyNotes = () => (
  <ul className="shipping-policy-notes">
    {NOTE_KEYS.map((key) => (
      <li key={key}>
        <Typography.Text italic>{t(`v2.cart.shippingPolicy.notes.${key}`)}</Typography.Text>
      </li>
    ))}
  </ul>
);

export default ShippingPolicyNotes;
